<template lang="pug">
  #index-footer.footer
    .footer-logo
      img(src="@/assets/17life_logo.png")
      a(:href="baseURL+'/m'")
    .footer-info
      p 版權所有 ©2023 康太數位整合股份有限公司<br>
        |Taiwan (R.O.C) 100 台北市中正區忠孝東路二段9號2樓
</template>
<script>
export default {
  props:{
    baseURL:{
      type: String,
      require: false,
      default: '.'
    }
  }
}
</script>
<style lang="scss">
  
</style>
